import { Store, select } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import * as CommentActions from '@core/actions/comment.actions';
import * as UserActions from '@core/actions/user.actions';
import * as FollowActions from '@core/actions/follow.actions';
import * as SeasonActions from '@core/actions/season.actions';
import * as DepartmentActions from '@core/actions/department.actions';
import * as fromTabsContainerPage from '@app/modules/side-panel/reducers/tabs-container.reducer';

@Component({
  selector: 'app-tabs-container',
  templateUrl: './tabs-container.component.html',
  styleUrls: ['./tabs-container.component.css']
})
export class TabsContainerComponent implements OnInit {
  comments$ = this.store.pipe(
    select(fromTabsContainerPage.getCommentsPopulated)
  );
  history$;
  constructor(private store: Store<any>) {
    this.store.dispatch(new UserActions.Load());
    this.store.dispatch(new CommentActions.Load());
    this.store.dispatch(new FollowActions.Load());
    this.store.dispatch(new SeasonActions.Load());
    this.store.dispatch(new DepartmentActions.Load());
  }

  ngOnInit() {}
}
